<template>
  <div>
    <v-dialog
      v-model="dialog"
      scrollable 
      persistent 
      max-width="600px"
      transition="dialog-transition"
    >
      <v-card>
        <v-card-title primary-title>
          Aprovações
          <v-spacer></v-spacer>
          <div>
            <v-select
              v-if="!show_done_approvals"
              class="pb-0 mb-n3"
              :items="rounds"
              v-model="selected_round"
              label="Rodada de aprovação"
            ></v-select>
          </div>
        </v-card-title>

        <v-card-text v-if="show_done_approvals">
          <div v-for="(done_approval, idx) in filtered_done_approvals" :key="idx">
            <v-card class="my-2" @click="openDoneApproval(done_approval)">
              <v-row>
                <v-col cols="12" sm="2" class="align-center justify-center d-flex">
                  <v-icon
                    large
                    :color="status_map[done_approval.status].color"
                  >
                    {{ status_map[done_approval.status].icon }}
                  </v-icon>
                </v-col>
                <v-col cols="12" sm="10" class="">
                  <v-row :class="by_screen.is_extra_small ? 'justify-center' : ''">
                    Status: {{ status_map[done_approval.status].text }}
                  </v-row>
                  <v-row :class="by_screen.is_extra_small ? 'justify-center' : ''">
                    Realizado em: {{ done_approval.done_at ?  $moment(done_approval.done_at).locale('pt-BR').format('lll') : 'À ser realizado' }}
                  </v-row>
                  <v-row :class="by_screen.is_extra_small ? 'justify-center' : ''">
                    Realizado por: {{ done_approval.done_by_name ? done_approval.done_by_name : 'À ser realizado' }}
                  </v-row>
                  <v-row :class="by_screen.is_extra_small ? 'justify-center' : ''">
                    Comentários: {{ done_approval.comment }}
                  </v-row>
                </v-col>
              </v-row>
            </v-card>
          </div>
        </v-card-text>

        <v-card-text v-if="!show_done_approvals">
          <div v-for="(approval_config, idx) in one_done_form.approval_configs" :key="idx">
            <v-card class="my-2" @click="selectApproval(approval_config)">
              <v-card-title :class="['subtitle-1 py-0', status_map[checkApprovalStatus(approval_config)].color]">
                <div class="title mb-0">
                  {{ status_map[checkApprovalStatus(approval_config)].text }}
                </div>
              </v-card-title>
              <v-row>
                <v-col cols="12" sm="4" class="my-3">
                  <div class="text-center">
                    <v-progress-circular
                      :rotate="0"
                      :size="100"
                      :width="15"
                      :value="calculePercentageApproved(approval_config)"
                      color="success"
                    >
                      {{ howManyApproved(approval_config).approved }}/{{ howManyApproved(approval_config).total }}
                    </v-progress-circular>
                  </div>
                </v-col>
                <v-col cols="12" sm="8" class=" my-3">
                  <v-row class="justify-center">
                    Total de aprovações: {{ howManyApproved(approval_config).total }}
                  </v-row>
                  <v-row class="justify-center">
                    Approvadas: {{ howManyApproved(approval_config).approved }}
                  </v-row>
                  <v-row class="justify-center">
                    Rejeitadas: {{ howManyApproved(approval_config).rejected }}
                  </v-row>
                  <v-row class="justify-center">
                    Pendentes: {{ howManyApproved(approval_config).pending }}
                  </v-row>
                </v-col>
              </v-row>
            </v-card>
          </div>
        </v-card-text>


        <v-card-actions class="justify-end">
          <v-btn
            color="error"
            @click="closeDialog()"
            text
          >
            Fechar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <dialog-approve-done-form
      v-if="approve_dialog"
      :one_done_approval="selected_done_approval"
      @close="handleCloseApproveDialog"
      @done="handleDoneApproval"
    ></dialog-approve-done-form>

    
  </div>
</template>

<script>
  import Api from "@/api";
  import { mapState } from 'vuex';
  import responsive from '@/mixins/responsive';

  export default {
    components: {
      DialogApproveDoneForm: () => import('./DialogApproveDoneForm.vue'),
    },
    props: {
      dialog: {
        type: Boolean,
        default: false
      },
    },
    mixins: [
      responsive
    ],
    data() {
      return {
        loading: false,
        done_approvals: [],
        status_map: {
          pending: {
            text: "Pendente",
            color: "grey",
            icon: "mdi-thumbs-up-down"
          },
          approved: {
            text: "Aprovado",
            color: "success",
            icon: "mdi-thumb-up"
          },
          rejected: {
            text: "Reprovado",
            color: "error",
            icon: "mdi-thumb-down"
          }
        },
        selected_done_approval: null,
        approve_dialog: false,
        show_done_approvals: false,
        filtered_done_approvals: [],
        selected_round: null
      }
    },
    mounted () {
      this.setCurrentRound();
      // this.getDoneApprovals();
    },
    methods: {
      handleDoneApproval(e) {
        console.log(e);
        this.selected_done_approval = null,
        this.approve_dialog = false;
        const idx = this.done_approvals.findIndex((da) => da.id === e.id);
        this.done_approvals.splice(idx, 1, {...e});
        this.selectApproval({id: e.approval_config_id});
        // this.getDoneApprovals();
      },
      closeDialog() {
        if (this.show_done_approvals === true) {
          this.show_done_approvals = false;
        } else {
          this.$emit('close');
        }
      },
      selectApproval(approval_config) {
        this.filtered_done_approvals = this.done_approvals.filter((da) => da.approval_config_id === approval_config.id);

        console.log("filtered =>", this.filtered_done_approvals)

        this.show_done_approvals = true;
      },
      calculePercentageApproved(approval_config) {
        if (this.done_approvals && this.done_approvals.length) {
          const approved = this.howManyApproved(approval_config).approved;
          const rejected = this.howManyApproved(approval_config).rejected;

          const done_approvals = approved + rejected;
          const total = this.howManyApproved(approval_config).total;
  
          return (done_approvals * 100) / total;
        }
      },
      checkApprovalStatus(approval_config) {
        if (this.done_approvals && this.done_approvals.length) {
          const approved = this.howManyApproved(approval_config).approved;
          const rejected = this.howManyApproved(approval_config).rejected;
          const pending = this.howManyApproved(approval_config).pending;
          const total = this.howManyApproved(approval_config).total;
  
          if (rejected > 0) {
            return 'rejected';
          } else if (rejected === 0 && pending > 0) {
            return 'pending';
          } else if (approved === total) {
            return 'approved';
          }
        }

        return 'pending'
      },
      howManyApproved(approval_config) {
        if (this.done_approvals && this.done_approvals.length) {
          const approval_config_id = approval_config.id;
          const done_approvals = this.done_approvals.filter((da) => da.approval_config_id === approval_config_id);

          return {
            total: done_approvals.length,
            approved: done_approvals.filter((da) => da.status === "approved").length,
            rejected: done_approvals.filter((da) => da.status === "rejected").length,
            pending: done_approvals.filter((da) => da.status === "pending").length
          }
        }
      },
      openDoneApproval(done_approval) {
        this.selected_done_approval = {...done_approval};
        this.approve_dialog = true;
      },
      handleCloseApproveDialog() {
        this.selected_done_approval = null,
        this.approve_dialog = false;
      },
      setCurrentRound() {
        this.selected_round = this.one_done_form.approval_configs[0].approvation_round;
      },
      async getDoneApprovals() {
        this.loading = true;
        console.log("selected_round => ", this.selected_round);

        try {
          const response = await Api.DoneApproval.index({done_form_id: this.one_done_form.id, approvation_round: this.selected_round});
          const data = response.data;
          console.log(data)
          this.done_approvals = [...data];
          console.log(this.done_approvals);
          // this.getEmployees();
        } catch (error) {
          console.log(error);
        } finally {
          this.loading = false;
        }
      },
      // getEmployees() {
      //   this.loading_employees = true;

      //   try {
      //     const response = await Api.Employee.index()
      //   } catch (error) {
          
      //   }
      // },
    },
    computed: {
      rounds() {
        let rounds = [];
        let current_round = this.one_done_form.approval_configs[0].approvation_round;

        console.log(current_round)

        for (current_round; current_round >= 1; current_round--) {
          rounds.push(current_round);
        }

        return rounds;
      },
      ...mapState({
        one_done_form: state=> state.DoneForm.oneDoneForm,
      })
    },
    watch: {
      rounds(newValue, oldValue) {
        this.setCurrentRound();
      },
      selected_round(newValue, oldValue) {
        if (newValue) {
          this.getDoneApprovals();
        }
      }
    },
  }
</script>

<style lang="scss" scoped>

</style>